import { useQuery } from "react-query";
import { EvaluationFormService } from "./evaluationFormService";

const useSearchUsersByName = (query) =>
  useQuery(
    ["search-users", query],
    () => EvaluationFormService.searchUsersByName(query).then((res) => res.data),
    {
      enabled: !!query,
      staleTime: 5 * 60 * 1000,
    }
  );

export default useSearchUsersByName;
